import { render, staticRenderFns } from "./collectOrder.vue?vue&type=template&id=1cd64481&scoped=true&"
import script from "./collectOrder.vue?vue&type=script&lang=js&"
export * from "./collectOrder.vue?vue&type=script&lang=js&"
import style0 from "./collectOrder.vue?vue&type=style&index=0&id=1cd64481&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd64481",
  null
  
)

export default component.exports